import React from 'react';
import styled from 'styled-components';
import ReactBackgroundImage from 'modules/react-backgroundImage';
import type { IResponsiveImageModel } from 'shared/interfaces/responsiveImage';
import { breakpoint, sizes } from 'variables';
import { ColorNordicGrey4 } from 'autogen/design-tokens/tokens';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';
import rippedEdgeVertical from './assets/svg/ripped-edge-vertical.svg';
import rippedEdgeHorizontal from './assets/svg/ripped-edge-horizontal.svg';
import imageHorizontal from './assets/images/rodekors-ukraine-horizontal.png';
import imageVertical from './assets/images/rodekors-ukraine-vertical.png';

const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    height: 125px;
    background-color: ${ColorNordicGrey4};
    overflow: hidden;

    ${breakpoint.up(sizes.md)} {
        order: 2;
        height: auto;
        width: auto;
        flex: 0 0 263px;
    }
`;

const StyledPicture = styled(PictureDeprecated)`
    /* -1px is to remove image behind the overlay, when zooming or odd DPR happens */
    position: absolute;
    bottom: -1px;
    left: -1px;
    right: -1px;

    ${breakpoint.up(sizes.md)} {
        top: -1px;
        right: initial;
    }

    img {
        height: auto;
        width: 100%;
        max-height: 100%;
        max-width: 100%;

        ${breakpoint.up(sizes.md)} {
            height: 100%;
            width: auto;
        }
    }
`;

export default function Image(): JSX.Element {
    const image = {
        sources: [
            {
                breakPoint: { maxWidth: sizes.md },
                images: [{ url: `${imageHorizontal}` }]
            },
            {
                breakPoint: { minWidth: sizes.md },
                images: [{ url: `${imageVertical}` }]
            }
        ],
        fallBackUrl: `${imageVertical}`,
        altText: 'Røde kors i Ukraine'
    } as IResponsiveImageModel;

    const overlayImage = {
        sources: [
            {
                breakPoint: { maxWidth: sizes.md },
                images: [{ url: `${rippedEdgeHorizontal}` }]
            },
            {
                breakPoint: { minWidth: sizes.md },
                images: [{ url: `${rippedEdgeVertical}` }]
            }
        ],
        fallBackUrl: `${rippedEdgeVertical}`,
        altText: ''
    } as IResponsiveImageModel;

    return (
        <ImageContainer>
            <ReactBackgroundImage image={image} lazyLoad />
            <StyledPicture {...overlayImage} />
        </ImageContainer>
    );
}
